import type { ClientItemId } from 'owa-client-ids';
import { isMessageFileMailboxInfo } from 'owa-client-types/lib/MessageFileMailboxInfo';
import { isGlobalFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import { TabType } from 'owa-tab-store';
import getTabById from 'owa-tab-store/lib/utils/getTabById';

/**
 * Whether the item being shown is a file rather than a server item: either a locally parsed
 * message file or a projection opened through file activation.
 *
 * Such items have no server item behind them, so actions that talk to the store's item id are
 * hidden or disabled for them. Kept in its own module, rather than inline in
 * shouldShowRibbonControl, so callers outside the ribbon can reuse it without pulling in that
 * module's dependency graph.
 */
export function isFileActivationProjection(
    itemId: ClientItemId | undefined,
    projectionTabId: string | null | undefined
): boolean {
    if (
        isGlobalFeatureEnabled('mon-msg-local-parser') &&
        isMessageFileMailboxInfo(itemId?.mailboxInfo)
    ) {
        return true;
    }

    if (!isGlobalFeatureEnabled('mon-file-eml-msg')) {
        return false;
    }

    const tab = getTabById(projectionTabId);

    if (tab?.type === TabType.SecondaryReadingPane) {
        // check if file projection
        return !!tab.data?.isFileActivation;
    }

    return false;
}
